/*

max error retry 

*/
import actionTypes from './action-types';
import modalState from './modal-state';
import axios from 'axios';
import { handleAxiosRequest, toUserErrorMessage } from './action-helper';

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));

const handleAxiosErrorGenerator = (dispatch, onError) => errorMessage => {
    dispatch(setError(errorMessage));
    onError(errorMessage);
};

export const reset = () => ({
    type: actionTypes.RESET
});

export const setError = (errorCode = null) => ({
    type: actionTypes.SET_ERROR,
    payload: toUserErrorMessage(errorCode)
});

export const close = () => ({
    type: actionTypes.CLOSE
});

export const startAuthAndOpenModal = (onComplete, onError) => {
    return async dispatch => {
        dispatch(reset());
        dispatch({
            type: actionTypes.START_AUTH
        });
        let { success, result } = await handleAxiosRequest(
            axios.post('/bankid/authenticate'),
            handleAxiosErrorGenerator(dispatch)
        );
        if (!success) {
            return;
        }
        dispatch({
            type: actionTypes.IN_PROGRESS,
            payload: result.autoStartToken
        });
        dispatch(bankIdPollProgress(onComplete, onError));
    };
};

/**
 * poll touchweb to see check if the user has made their bank id auth.
 * this might take some time since the user needs to open up their mobile app with bank id
 */
const bankIdPollProgress = (onComplete, onError) => async (
    dispatch,
    getState
) => {
    const state = getState();
    if (state.bankId.modalState !== modalState.IN_PROGRESS) {
        return;
    }
    let { success, result } = await handleAxiosRequest(
        axios.get('/bankid/progress?' + new Date().getTime()),
        handleAxiosErrorGenerator(dispatch, onError)
    );
    if (!success) {
        return;
    }
    if (result.isCompleted) {
        dispatch({
            type: actionTypes.COMPLETED
        });
        onComplete();
        return;
    }
    await sleep(3000);
    dispatch(bankIdPollProgress(onComplete, onError));
};
